module.exports = __webpack_public_path__ + "img/promo-nov.69f5d332.jpg";